import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
// import { AiFillEye } from 'react-icons/ai';
import Button from '../../../Component/Button/Button';
import CustomMaterialTable from '../../../Component/CustomMaterialTable';
import SearchInput from '../../../Component/SearchInput';
import SideBarSkeleton from '../../../Component/SideBarSkeleton';
import { recordsLimit } from '../../../config/apiUrl';
import classes from './PropertyRequests.module.css';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import useDebounce from '../../../CustomHooks/useDebounce';
import PropertyRequestDetailModal from '../../../modals/PropertyRequestDetailModal';
import {
  useDeletePropertyRequestsMutation,
  useGetAllInquiryMessageAndRequestQuery,
  useGetAllPropertyRequestsQuery
} from '../../../store/apiSlice/apiSlice';
import Tabs from '../../../Component/Tabs';
import { FaCircleNotch } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { isMobileViewHook } from '../../../CustomHooks/isMobileViewHook';

function PropertyRequests() {
  const { t } = useTranslation('dashboardPropertyRequests');
  const { user } = useSelector((state) => state?.authReducer);
  const [searchText, setSearchText] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [page, setPage] = useState(1);
  // const [dateFilter, setDateFilter] = useState(dateFilterOptions[0]);
  const [showModal, setShowModal] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [is360, setIs360] = useState(false);

  const tabsData = [
    {
      icon: <FaCircleNotch />,
      text: t('propertyRequests'),
      id: 1,
      type: 'property-request'
    },
    {
      icon: <FaCircleNotch />,
      text: t('inquiry'),
      id: 2,
      type: 'inquiry'
    },
    {
      icon: <FaCircleNotch />,
      text: t('message'),
      id: 3,
      type: 'inquiry'
    }
  ];

  const [selectedTab, setSelectedTab] = useState(tabsData[0]);
  // const headings = [
  //   { id: 'id', label: t('table.col1'), renderValue: (_, __, i) => i + 1 },
  //   { id: 'fullName', label: t('table.col2') },
  //   { id: 'email', label: t('table.col3') },
  //   { id: 'phoneNo', label: t('table.col4'), renderValue: (e) => e?.phoneNumber },
  //   { id: 'budget', label: t('table.col5'), renderValue: (e) => `$${e?.budget}` },
  //   { id: 'options', label: t('table.col6'), align: 'center' }
  // ];

  const debounceSearch = useDebounce(searchText, 500);
  const { data, isLoading, isFetching } = useGetAllPropertyRequestsQuery({
    limit: recordsLimit,
    page: page,
    search: debounceSearch
  });

  const {
    data: inquiryData,
    isLoading: isLoadingInquiryMessage,
    isFetchingInquiryMessage
  } = useGetAllInquiryMessageAndRequestQuery(
    {
      limit: recordsLimit,
      page: page,
      search: debounceSearch,
      type: selectedTab?.text?.toLowerCase()
    },
    {
      // skip: selectedTab?.text == 'propertyRequests'
      skip: selectedTab?.type == 'property-request'
    }
  );

  // headings
  const headings = [
    { id: 'id', label: t('table.col1'), renderValue: (_, __, i) => i + 1 },
    { id: selectedTab.id == 1 ? 'fullName' : 'name', label: t('table.col2') }, //name
    { id: 'email', label: t('table.col3') }, // message, preferredContactMethod, entity, createdBy
    {
      id: selectedTab.id == 1 ? 'phoneNo' : 'phone',
      label: t('table.col4'),
      renderValue: (e) => e?.phoneNumber || e?.phone
    },
    ...(selectedTab.id == 1
      ? [
          {
            id: 'budget',
            label: t('table.col5'),
            renderValue: (e) => `$${e?.budget}`
          }
        ]
      : []),

    {
      id: 'seen',
      label: t('table.col7'),
      renderValue: (e) => (isSeen(e) ? t('seen') : t('unseen'))
    },
    { id: 'options', label: t('table.col6'), align: 'center' }
  ];

  const [deleteRecordsApi, { isLoading: isDeleting }] = useDeletePropertyRequestsMutation();
  //  delete api
  const deleteMultiple = async () => {
    const res = await deleteRecordsApi({
      ids: selectedRows?.map((item) => item._id),
      type: selectedTab?.type
    });
    if (res?.data) {
      toast.success(
        `${t(toast.propertyRequest)} ${selectedRows?.length > 1 ? 's' : ''}${t(
          toast.deletedSuccessfully
        )}`
      );
      setSelectedRows([]);
    }
  };

  // check if data is seen
  const isSeen = (data) => {
    if (Array.isArray(data?.seenBy)) {
      return data?.seenBy.includes(user?._id);
    }
    if (data?.seen === true) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    isMobileViewHook(setIs360, 360);
  }, []);

  return (
    <SideBarSkeleton>
      <Container fluid className={classes.page}>
        <Row>
          <Col md={12} className={classes.mb58}>
            <div className={classes.header}>
              <div className={classes.left}>
                <SearchInput
                  placeholder={t('searchByName')}
                  setter={setSearchText}
                  state={searchText}
                  variant="dashboard"
                  containerStyle={{
                    width: is360 ? '250px' : '300px',
                    border: '1px solid #999',
                    overflowY: 'hidden'
                  }}
                />
                {/* <DropDown
                  label={'Sort By Date'}
                  containerClassName={classes.dropDownContainer}
                  customStyle={{ padding: '0px 6px', minHeight: '40px', minWidth: '200px' }}
                  options={dateFilterOptions}
                  setValue={(e) => {
                    setDateFilter(e);
                  }}
                  value={dateFilter}
                  placeholder={'Select Date'}
                  // isClearable={true}
                /> */}
              </div>

              <Button
                borderRadius={'8px'}
                className={classes.deleteBtn}
                disabled={selectedRows?.length == 0 || isDeleting}
                onClick={deleteMultiple}>
                {isDeleting ? t('deleting') : t('delete')}
              </Button>
            </div>
          </Col>
          <Col md={12} className="d-flex justify-content-between flex-wrap">
            <h5 className={classes.heading}>{t('title')}</h5>
            <Tabs
              tabsData={tabsData}
              value={selectedTab}
              tabClass={classes.tab}
              setValue={(tab) => {
                setSelectedTab(tab);
                setPage(1);
                setSearchText('');
              }}
              className={classes.tabs}
            />
          </Col>
          <Col md={12}>
            <CustomMaterialTable
              headings={headings}
              data={selectedTab.id == 1 ? data?.data : inquiryData?.data}
              isLoading={
                isLoading || isFetching || isLoadingInquiryMessage || isFetchingInquiryMessage
              }
              showOptionsColumn
              // options={[
              //   {
              //     label: t('table.options.view'),
              //     icon: <AiFillEye size={18} />,
              //     onClick: (e, a) => {
              //       setSelectedItem(a);
              //       setShowModal('detail');
              //     }
              //   }
              // ]}
              optionsToggle={false}
              options={[]}
              onOptionClick={() => {}}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              allowMultipleSelection
              rowsPerPage={recordsLimit}
              limit={recordsLimit}
              totalRecords={Math.ceil(data?.totalRecords / recordsLimit)}
              page={page}
              setPage={setPage}
              setSelectedItemParent={setSelectedItem}
              setShowModalParent={setShowModal}
            />
          </Col>
        </Row>
      </Container>

      {showModal == 'detail' && (
        <PropertyRequestDetailModal
          t={t}
          data={selectedItem}
          show={showModal == 'detail'}
          setShow={setShowModal}
          isSeen={isSeen(selectedItem)}
          type={selectedTab.type}
        />
      )}
    </SideBarSkeleton>
  );
}

export default PropertyRequests;
